const CLEAN = {
    onReady() {
        let columns = document.querySelectorAll('.layout-block .column');
        columns.forEach(column => {
            CLEAN.addGapToMultiSectionColumn({node: column});
            CLEAN.addMinHeightToLayoutElements({node: column});
            CLEAN.mobileOrder({node: column});
        });
        CLEAN.buttons();
        // CLEAN.sections(); disabled 
        CLEAN.jumpmarks();
        CLEAN.singleFormButton();
        CLEAN.accessibilityFormTextContrast();
        CLEAN.textRightToCenter();
        CLEAN.modulShadow();
        CLEAN.responsiveImages();
        CLEAN.hideMobile();
        CLEAN.mobileBlogGlossar();
        CLEAN.mobileBackgrounds();
        CLEAN.createModuleIndex();
        CLEAN.coloredBullets();
        CLEAN.alignSelf();
        CLEAN.addGapToLayoutElement();
        CLEAN.openExternalLinksNewTab();
    },
    /*********************
    * Jumpmarks
    *********************/
    jumpmarks() {
        let anchors = document.querySelectorAll('a');
        anchors.forEach(anchor => {
            anchor.addEventListener('click', event => { 
                let urlPart = anchor.href.split('#');
                let mark    = urlPart.length > 1 ? urlPart[1] : null;
                if (mark === null) return;
                let markNode = document.getElementById(mark);
                if (markNode === null) return;
                event.preventDefault();
                window.location.href = location.protocol + '//' + location.host + location.pathname + '#' + mark;
            });
        });
    },
    /*********************
     * Remove margin-bottom values from surrounding paragraph
     *********************/
    buttons() {
        let buttons = document.querySelectorAll('.button, .button--intern, .button--cta');
        buttons.forEach(button => {
            let parent = button.parentNode;
            (parent.tagName === 'P') && (parent.style.marginBottom = '0');
        });
    },
    /*********************
     * Adjust space between two sections of same color
     *********************/
    sections() {
        let sections = document.querySelectorAll('section');
        sections.forEach(section => {
            let sibling = section.nextSibling;
            if (sibling === null || sibling.tagName !== 'SECTION') return;
            (section.classList.contains('white') && sibling.classList.contains('white')) && (section.style.paddingBottom = '0');
            (section.style.backgroundColor === sibling.style.backgroundColor) && (section.style.paddingBottom = '0');
        });
    },
    /*********************
    * Beautify forms with ONLY ONE input field
    *********************/
    singleFormButton() {
        if (window.innerWidth < 870) return;
        let forms = document.querySelectorAll('.form');
        forms.forEach(form => {
            let inputs = form.querySelectorAll('input:not([type="hidden"])');
            let button = form.querySelector('.button--cta');
            if (inputs.length === 1) {
                Object.assign(button.style, {
                    position: 'absolute', 
                    top: '.25rem', 
                    right: '0', 
                    height: '2.375rem'
                });
                inputs[0].style.width = `calc(100% - 1rem - ${button.clientWidth}px )`;
            }
        });
    },
    /*********************
    * Contrast of text and Background in Forms
    *********************/
    accessibilityFormTextContrast() {
        let formWrappers = document.querySelectorAll('.form-wrapper');
        formWrappers.forEach(wrapper => {
            let bgStyleValue = wrapper.style.backgroundColor; // if hex it gets auto-convert to rgb values, alternative it can be a CSS-variable
            if (bgStyleValue === '') return;
            let regex    = new RegExp(/\s*\(.*?\)\s*/g);
            let value    = bgStyleValue.match(regex)[0].replace('(', '').replace(')', '');
            let valueArr = value.split(',');
            if (valueArr.length === 1) { // css variable
                let hex = getComputedStyle(document.documentElement).getPropertyValue(value);
                hex = hex.replace('#', '');
                let bigint = parseInt(hex, 16);
                var r = (bigint >> 16) & 255;
                var g = (bigint >> 8) & 255;
                var b = bigint & 255;
            } else { // hex color
                var r = parseInt(valueArr[0]);
                var g = parseInt(valueArr[1]);
                var b = parseInt(valueArr[2]);
            }
            let threshold  = 130; // about half of 256. Lower threshold equals more dark text on dark background
            let brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000; // W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast
            if (brightness > threshold) {
                var textColor = '#000000';
            } else { 
                var textColor = '#ffffff';
            }
            let headings  = wrapper.querySelectorAll('.form__heading');
            let itemNames = wrapper.querySelectorAll('.form__item__name');
            let legals    = wrapper.querySelectorAll('.form__legal-notice');
            [headings, itemNames, legals].forEach(elements => {
                elements.forEach(element => {
                    (element !== null) && (element.style.color = textColor);
                })
            });
        });
    },
    /*********************
    * Clean text alignment on mobile, reset fixed image width
    *********************/
    textRightToCenter() {
        if (window.innerWidth > 870) return;
        let textModules = document.querySelectorAll('.text-editor');
        let gridModules = document.querySelectorAll('.grid');
        [textModules, gridModules].forEach(modules => {
            modules.forEach(module => {
                let items = module.querySelectorAll('*');
                items.forEach(item => {
                    let children = Array.from(item.children); 
                    children.forEach(child => {
                        (child.style.textAlign === 'right') && (child.style.textAlign = 'center');
                    });
                });
            });
        });
    },
    /*********************
    * Adjust shadow image within shadow module
    *********************/
    modulShadow() {
        if (window.innerWidth < 870) return;
        let modules = document.querySelectorAll('.shadow');
        modules.forEach(module => {
            let content = module.querySelector('.shadow__content');
            let image   = module.querySelector('.shadow__image-container');
            image.style.height = content.clientHeight + 'px';
        });
    },
    /*********************
    * Remove fixed width from images if they expand the screen size
    *********************/
    responsiveImages() {
        let images = document.querySelectorAll('img');
        images.forEach(image => {
            (parseInt(image.style.width) > window.innerWidth) && (Object.assign(image.style, {width: '100%', height: 'auto'}));
        });
    },
    /*********************
    * Remove parent from mobile hidden elements
    *********************/
    hideMobile() {
        if (window.innerWidth > 680) return;
        let hiddenElements = document.querySelectorAll('.hide-mobile');
        hiddenElements.forEach(element => {
            let parentParagraph = element.closest('p');
            if (parentParagraph == null) return;
            parentParagraph.remove();
        });
    },
    /*********************
    * Remove parent from mobile hidden elements
    *********************/
    mobileBlogGlossar() {
        if (window.innerWidth > 1412) return;
        let pinned    = document.querySelector('.glossar-entry.pinned');
        if (pinned == null) return;
        let container = pinned.closest('a');
        let parent    = container.parentNode;
        let tagCloud  = container.previousElementSibling.previousElementSibling;
        parent.insertBefore(container, tagCloud);
    },
    /*********************
    * Mobile Background Images
    *********************/
    mobileBackgrounds() {
        if (screen.availHeight < screen.availWidth) return; // is landscape
        let sections = document.querySelectorAll('[data-mobile-bg]');
        sections.forEach(section => {
            let imagePath = section.dataset.mobileBg;
            let image     = imagePath.replace('/media/mobile_bg/', '');
            if (image === '') return;
            section.style.backgroundImage = `url("${imagePath}")`;
        });
    },
    /*********************
    * Create Module Index
    *********************/
    createModuleIndex() {
        const blog = document.getElementById('blog');
        if (blog === null) return;
        let sections    = document.querySelectorAll('.content-index');
        let textEditors = document.querySelectorAll('.text-editor');
        let headlines   = [];
        var ii          = 0;
        // Only Text Editor Modules
        textEditors.forEach(editor => {
            let editorHeadlines = editor.querySelectorAll('h2');
            // Build Headlines Array
            editorHeadlines.forEach(headline => {
                headlines.push(headline);
            })
        });
        // Set Ids for Jumpmarks
        headlines.forEach(headline => {
            headline.id = `headline-${ii}`;
            ii++;
        });
        // Build List
        sections.forEach(section => {
            let markup = '';
            headlines.forEach(headline => {
                if (Utils.isAfter(headline, section)) {
                    markup += `<a class="content-index__link" href="${window.location.href.replace(window.location.hash, '')}#${headline.id}">${headline.innerHTML}</a>`;
                }
            });
            section.querySelector('.content-index__container').insertAdjacentHTML('beforeend', markup);
        });
    },
    /*********************
    * Colored Bullets
    *********************/
    coloredBullets() {
        let listitems = document.querySelectorAll('li');
        listitems.forEach(item => {
            if (item.firstChild.tagName === 'SPAN' && item.firstChild.style.color !== '') {
                item.style.color = item.firstChild.style.color;
            }
        });
    },
    /*********************
    * Order Flex Columns 
    *********************/
    mobileOrder({node}) {
        if (window.innerWidth > 768) return;
        let children = node.querySelectorAll('section');
        let parent   = node.closest('.columns');
        Object.assign(parent.style, {
            marginRight:  '0',
            marginLeft:  '0'
        });
        children.forEach(child => {
            let margin = child.classList.contains('akkordeon') ? '0 auto' : '0 auto 1rem auto';
            Object.assign(child.style, {
                display: 'block',
                width:   '100%',
                margin:  margin
            });
            parent.appendChild(child);
        });
        node.remove();
    },
    /*********************
    * Add Gap to Column Elements
    *********************/
    addGapToMultiSectionColumn({node}) {
        let children = node.childNodes;
        if (node.classList.contains('is-12')) return;
        if (children.length > 1) {
            for (var ii = 0; ii < children.length - 1; ii++) { // exclude last child
                children[ii].style.marginBottom = '1.5rem';
            }
        }
    },
    /*********************
    * Add Min Height to Layout Elements
    *********************/
    addMinHeightToLayoutElements({node}) {
        let layout  = node.closest('.layout-block');
        if (layout === null) return;
        let columns = node.closest('.columns');
        let section = node.firstElementChild;
        if (layout.style.minHeight === '0px') return;
        columns.style.minHeight = layout.style.minHeight;
        section.style.minHeight = layout.style.minHeight;
    },
    /*********************
    * Add Gaps to Columns
    *********************/
    addGapToLayoutElement() {
        let layoutBlocks = document.querySelectorAll('.layout-block');
        layoutBlocks.forEach(block => {
            let columns = document.querySelectorAll('.columns'); 
            columns.forEach(column => {
                column.classList.add(column.closest('.layout-block').dataset.gap)
            });
        });
    },
    alignSelf() {
        let nodes = document.querySelectorAll('[data-align-self]');
        nodes.forEach(node => {
            node.parentNode.classList.add(node.dataset.alignSelf);
        });
    },
    openExternalLinksNewTab() {
        let anchors = document.querySelectorAll('a');
        anchors.forEach(anchor => {
            var url  = anchor.href;
            var cond = ['andreagrundmann.de', '45grad.de'];
            if (cond.some(item => url.includes(item))) return; // url.includes('andreagrundmann.de') || url.includes('45grad.de')
            if (!url.includes('http')) return;
            anchor.target = '_blank';
        });
    }
}